<ng-container *ngIf="config">
  <div *ngIf="config.displayLevel === 'screen'">
    DEBUG INFORMATION:
    <pre>{{ configAsJson }}</pre>
  </div>
</ng-container>
